export default class StripeError extends Error {
  constructor(error) {
    super(error);
    this.name = "StripeError";
    this.code = error.code;
    this.declineCode = error.decline_code;
    this.message = error.message;
    this.type = error.type;
    this.setup = error.setup_intent
    this.payment = error.payment_method
    this.card = {
      country: error.payment_method.card.country,
      brand: error.payment_method.card.brand,
      funding: error.payment_method.card.funding
    }
  }
}